import React, { useState } from 'react';
import {
    Button,
    Input,
    Slider,
    Spinner,
    Toast,
    Checkbox,
    TextArea
} from '@kaleyra/emmy';
import Styles from '../../AutomatedReports/automatedReports.module.scss';
import { useTranslation } from 'react-i18next';
import ErrorIcon from '../../../../assets/error.svg';
import { validateEmail } from '../../../../utils';

export type MapStatePropsType = {
    sidebarVisibility: any;
};

export type DispatchPropsType = {
    onClose: () => void;
};

const NewConfiguration: React.FC<MapStatePropsType & DispatchPropsType> = ({
    onClose,
    sidebarVisibility
}) => {

    const { t } = useTranslation();
    const [emailIdsStr, setemailIdsStr] = useState('');
    const [emailIdsStrErr, setemailIdsStrErr] = useState('');

    const getFooter = (): React.ReactNode => {
        return (
            <div className={Styles.footer} >
                <Button type="tertiary" onClick={onClose}>
                    {t("mainCancel")}
                </Button>
                <Button className={Styles.save}
                > {t("mainSave")}
                </Button>
            </div>
        );
    };

    const validateCheck = (field: string) => {
        if (field === 'emailIdsStr') {
            if (emailIdsStr.trim() === '') {
                return t('titleReq');
            }

            let emails = emailIdsStr.split(",");
            for (let i = 0; i < emails.length; i++) {
                if (!validateEmail(emails[i])) {
                    return t('verifyValidEmail');
                }
            }
            return;
        }
    };

    const handleEmailsOnBlur = () => {
        let errMsg = validateCheck('emailIdsStr');
        if (errMsg) {
            setemailIdsStrErr(errMsg);
            return;
        } else {
            setemailIdsStrErr('');
            return;
        }
    };

    const validateFields = (field: string): 'error' | undefined => {
        if (validateCheck(field)) {
            return "error";
        }
        return undefined;
    };

    const setErrors = (field: string) => {
        let errMsg = validateCheck(field);
        if (errMsg) {
            return (
                <div className={Styles.errorClass}>
                    <img
                        src={ErrorIcon}
                        alt=""
                        className={Styles.errorIcon}
                    />
                    {errMsg}
                </div>
            );
        }
    };

    const getContent = () => {

        return (
            <div className={Styles.container}>
                <Input
                    placeholder={t("reportType")}
                    label={t("reportType")}
                    value={'Summary'}
                    disabled
                />
                <Input
                    placeholder={t("tabChannels")}
                    label={t("tabChannels")}
                    value={'SMS'}
                    disabled
                />
                <p className={Styles.reportFrequency}>Report Frequency</p>
                <div className={Styles.checkbox}>
                    <Checkbox
                        label={t("daily")}
                        description={t("dailyReportDesc")}
                    />
                </div>
                <div className={Styles.checkbox}>
                    <Checkbox
                        label={t("weekly")}
                        description={t("weeklyReportDesc")}
                    />
                </div>
                <div className={Styles.checkbox}>
                    <Checkbox
                        label={t("monthly")}
                        description={t("monthlyReportDesc")}
                    />
                </div>
                <TextArea
                    bordered
                    placeholder={t("KLR02622")}
                    bottomLabelType='default'
                    bottomLabel={t("BLD00141")}
                    label={t("KLR02622")}
                    onChange={(e: any) => {
                        setemailIdsStrErr('');
                        setemailIdsStr(e.target.value);
                    }}
                    onBlur={() => {
                        handleEmailsOnBlur();
                    }}
                    value={emailIdsStr}
                    showBottomLabelSpace
                />
            </div>
        )
    }

    return (
        <Slider
            containerId="root-modal"
            onClose={onClose}
            visibility={sidebarVisibility}
            footer={getFooter()}
            title={t("KLR03007")}
        >
            {getContent()}
        </Slider>
    );
};

export default NewConfiguration;
